<label class="group/checkbox flex cursor-pointer items-center gap-8" [for]="inputId">
    <input
        class="peer sr-only"
        [id]="inputId"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onModelChange(!checked())"
        (keydown.enter)="$event.preventDefault(); onModelChange(!checked())"
        type="checkbox"
    />

    <div
        class="group-hover/checkbox:border-blue group-has-[:checked]/checkbox:bg-blue flex size-[22px] min-w-[22px] items-center justify-center border-2 transition-colors peer-focus-visible:outline"
        [ngClass]="{
            'border-grey-400 bg-grey-100 cursor-not-allowed opacity-70': disabled(),
            'border-grey-400 bg-white': !disabled(),
        }"
    >
        <i
            class="icon-check text-22 hidden transition-colors group-has-[:checked]/checkbox:flex"
            [ngClass]="{
                'text-grey-400 opacity-70': disabled(),
                'text-white': !disabled(),
            }"
            aria-hidden="true"
        ></i>
    </div>

    <span
        class="z-10 leading-22 transition-colors"
        [ngClass]="{
            'bg-blue text-14 px-8 py-2 font-medium text-white': asBadge(),
            'text-16': !asBadge(),
        }"
    >
        <ng-content />
    </span>
</label>
